import type { ChatMessage } from '../types';
import { PipelineTrail } from './PipelineTrail';
import { FormattedMessage } from './FormattedMessage';
import { CodeBlockView } from './CodeBlockView';

export function MessageBubble({ message }: { message: ChatMessage }) {
  const isUser = message.role === 'user';
  const isSystem = message.role === 'system';
  const isStreaming = message.status === 'streaming';
  const isError = message.status === 'error';
  const hasSteps = !isUser && message.pipelineSteps && message.pipelineSteps.length > 0;

  return (
    <div
      className={`agent-message ${message.role} ${isError ? 'error' : ''}`}
      data-testid={`agent-message-${message.role}`}
      data-status={message.status}
    >
      {!isUser && !isSystem && (
        <div className="message-avatar">
          <img src="/gottibot.png" alt="Gotti bot" />
        </div>
      )}
      <div className="message-content">
        {isSystem ? (
          <div className="system-message" data-testid="system-message">{message.content}</div>
        ) : (
          <>
            {hasSteps && (
              <PipelineTrail
                steps={message.pipelineSteps!}
                modifiedFiles={message.modifiedFiles}
              />
            )}

            <div className="message-text" data-testid="message-text">
              <FormattedMessage content={message.content} />
              {isStreaming && <span className="typing-cursor">▋</span>}
            </div>

            {message.codeBlocks && message.codeBlocks.length > 0 && (
              <div className="message-code-blocks" data-testid="message-code-blocks">
                {message.codeBlocks.map((block) => (
                  <CodeBlockView key={block.id} block={block} />
                ))}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
